import React from 'react';
import ReactLoading from 'react-loading';
import { useSelector } from '../Redux/store';
const FullCoverLoadingWithAnime = React.memo(() => {
    const isLoading = useSelector(state => state.loadingWithAnime);
    return (React.createElement(React.Fragment, null, isLoading &&
        React.createElement("div", { className: "fixed w-full h-full z-999999 bg-gray-700 bg-opacity-40 flex flex-col items-center justify-center" },
            React.createElement("div", { className: "px-6 pt-4 pb-12 bg-white rounded-2xl" },
                React.createElement("div", { className: "h-28 w-32" },
                    React.createElement(ReactLoading, { type: 'cylon', className: "opacity-80", color: '#6b7280', height: '100%', width: '100%' }),
                    React.createElement("div", { className: "text-lg font-bold w-full text-center", style: { color: `#6b7280` } }, "\u51E6\u7406\u4E2D"))))));
});
export default FullCoverLoadingWithAnime;
